export const environment = {
    production: false,
    supabaseUrl: 'https://consleiyvglxpoxrugax.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNvbnNsZWl5dmdseHBveHJ1Z2F4Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY5NTgyNDA1MCwiZXhwIjoyMDExNDAwMDUwfQ.9z-DcKPE603vQDxc9ltiFR7dkaOsmykyguf6UXOTrg8'
}